import { Component, OnInit, OnChanges, Output, Input, SimpleChanges, EventEmitter, forwardRef, OnDestroy } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import { LoaderService } from '../../services/loader.service';
import { AlertsService } from '../../services/alerts.service';
import { AppService } from '../../shared/services/app.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Observable, Subscription } from 'rxjs';
import { NgxImageCompressService } from 'ngx-image-compress';
// import { jsPDF } from "jspdf";
import _moment from 'proxies/dayjs';
import { ImageCroppedEvent } from '../image-cropper/interfaces';
import { DialogService } from '../dialog/dialog.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { ShowPdfComponent } from './show-pdf/show-pdf.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageViewComponent } from './show-image/image-view.component';
import { ClickPhotoComponent } from './click-photo/click-photo.component';
import { UtilService } from '../../services/util.service';
import { FormService } from '../form/form.service';
import { inspectUploadFile, requiresInspection } from '../../services/upload-file-guard';
@Component({
    selector: 'dhs-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileUploaderComponent,
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FileUploaderComponent), multi: true
        }],
    standalone: false
})
export class FileUploaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input('value') _value: any;
  @Input() multiple: boolean = false;
  @Input() icon_with_text: boolean = false;
  @Input() formatsAllowed: string = '.jpg,.png,.pdf,.docx,.txt,.jpeg,.xlsx,.xls';
  @Input() maxSize: number = 15;
  @Input() formAction: string;
  @Input() config: any = {}; // Remove in future
  @Input() resetUpload: boolean = this.config['resetUpload'];
  @Output() uploadResponse = new EventEmitter();
  @Input() crop_image: boolean = true;
  @Input() compress_image: boolean = true;
  @Input() resource: string;
  @Input() datasource: object = {};
  @Input() formSubmit: boolean = false;
  @Input() delete_document: string = "delete";
  @Input() multipleImageUpload: boolean = false;
  @Input() capture_image: boolean = false;
  @Output() focus_out = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() documentInfo = new EventEmitter<any>();
  @Input() question: any;
  @Input() disabled: boolean = false;
  // Optional pixel-dimension check, run on the final cropped output right before
  // upload (see crop()). Unset by default so existing consumers are unaffected -
  // only opt in by passing both expectedWidth and expectedHeight.
  @Input() expectedWidth: number;
  @Input() expectedHeight: number;
  @Input() matchExactDimension: boolean = true;
  // Defaults to false so existing consumers keep showing rejections inline-only
  // (via notAllowedList) - opt in to also surface format/size/dimension errors
  // as a toast.
  @Input() showValidationToast: boolean = false;
  copyURLbtn: boolean = false;

  theme: string;
  id: number;
  hideProgressBar: boolean;
  uploadAPI: string;
  headers: any;
  hideResetBtn: boolean;
  hideSelectBtn: boolean;
  attachPinText: string;
  uploadBtnText: string;
  moment = _moment
  idDate: number = +new Date();
  reg: RegExp = /(?:\.([^.]+))?$/;
  private selectionSeq = 0; // #205111 - identifies the latest file selection while its content is inspected
  selectedFiles: Array<any> = [];
  notAllowedList: Array<Object> = [];
  Caption: Array<string> = [];
  singleFile = true;
  progressBarShow = false;
  uploadBtn = false;
  uploadMsg = false;
  afterUpload = false;
  uploadClick = true;
  uploadMsgText: string;
  uploadMsgClass: string;
  percentComplete: number;
  imageSrc: any;
  imageMimeType: Array<string> = ["apng", "bmp", "ico", "cur", "jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "tif", "tiff", "webp","svg+xml"]
  file: FileList;
  file_id: any;
  propagateChange = (_: any) => { };
  imageURL = ' ';
  docData: any;
  Arr = <any>[]
  result: string;
  imageChangedEvent: any = '';
  imageChanges: File;
  croppedImage: boolean = false;
  cropedImage: string;
  fileData: any;
  showUploadButton: boolean = false;
  readerFileData: FileReader;
  showmultipleImage: boolean = true;
  hideSelectImageButton: boolean = true;
  fileMimeTypebollean: boolean = false;
  currentMimeType: string = 'png';
  cropDone: ImageCroppedEvent;
  configFile: any = {};
  fileInfo: any = '';
  showCaptureImage: boolean = true;
  cardData: any;
  archive_metadata_check: boolean = false;
  isInfoPopoverOpen: boolean = false;
  private subs = new Subscription();

  constructor(
    private baseService: BaseService,
    private appService: AppService,
    private authenticationService: AuthenticationService,
    private loader: LoaderService,
    private alertService: AlertsService,
    private imageCompress: NgxImageCompressService,
    private dialogService: DialogService,
    private sanitizer: DomSanitizer,
    private formService: FormService,
    private utilService: UtilService
  ) { }

  ngOnChanges(rst: SimpleChanges) {
    this.id =
      this.config['id'] ||
      parseInt((this.idDate / 10000).toString().split('.')[1]) +
      Math.floor(Math.random() * 20) * 10000;
    if (rst['config']) {
      this.theme = this.config['theme'] || '';
      // this.id =
      //   this.config['id'] ||
      //   parseInt((this.idDate / 10000).toString().split('.')[1]) +
      //   Math.floor(Math.random() * 20) * 10000;
      this.hideProgressBar = this.config['hideProgressBar'] || false;
      this.hideResetBtn = this.config['hideResetBtn'] || false;
      this.hideSelectBtn = this.config['hideSelectBtn'] || false;
      this.uploadBtnText = this.config['uploadBtnText'] || 'Upload';
      //this.maxSize = this.config['maxSize'] || 20;
      // this.uploadAPI = this.config["uploadAPI"]["url"] || '';
      // this.formatsAllowed =
      //   this.config['formatsAllowed'] || '.jpg,.png,.pdf,.docx,.txt,.gif,.jpeg';
      //this.multiple = false; //this.config['multiple'] || false;
      // this.headers = this.config["uploadAPI"]["headers"] || {};
      this.attachPinText =
        this.config['attachPinText'] || 'Attach supporting documents..';
    }
    if (this.formAction == 'VIEW') {
      this.hideSelectBtn = true;
      this.showCaptureImage = false;
    }
    if (rst['resetUpload']) {
      if (rst['resetUpload'].currentValue === true) {
        this.resetFileUpload();
      }
    }
  }

  // validate(control: FormControl): ValidationErrors | null {
  //   return { 'custom': true };
  // }

  ngOnInit() {
    // debugger;
    //for view
    if (this.appService.checkNativeApp()) {
      if (this.formatsAllowed != "") {
        let format = this.formatsAllowed.split(",");
        var index = format.indexOf(".dcm");
        if (index !== -1) {
          format.splice(index, 1);
          this.formatsAllowed = format.join(",");
        }
      }
    }
    console.log("compress_image", this.compress_image);
    if (this.value != undefined && this.value) {
      this.file_id = this.value;
    }

    if (!this.config) {
      this.config = this['data'];
    }
    this.resetUpload = false;

    // for diagnostic and others s3Document archive metadata config check
    if (this.question != undefined && this.question && this.question.s3Document != undefined && this.question.s3Document && this.question?.resource) {
      this.subs.add(this.baseService.get('GET_PAGE', "", 'archive_metadata', "system-management", "adaptor:AMAZONS3,documentType:"+this.question.resource).subscribe(res_ => {
        console.log("Response of archive_metadata : ", res_);
        if (res_ && res_.count == 1 && res_.resource && res_.resource.length == 1){
          this.archive_metadata_check = true;
        }
      }));
    }

    this.copyURLbtn = this.question?.copyURLbtn;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.file_id != null)
      this.getfileData();
  }
  resetFileUpload() {
    this.selectedFiles = [];
    this.Caption = [];
    this.notAllowedList = [];
    this.uploadMsg = false;
    this.uploadBtn = false;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.cropedImage = event.base64;
    if (this.cropDone == undefined) {
      this.cropDone = event;
      this.configFile.settleImage = true;
    } else {
      if (this.cropDone.height != event.height) {
        this.configFile.settleImage = false;
        this.cropDone = event;
      } else if (this.cropDone.width != event.width) {
        this.configFile.settleImage = false;
        this.cropDone = event;
      } else {
        this.configFile.settleImage = true;
        this.cropDone = event;
      }
    }

  }


  compressFile(image, fileName, reader) {
    var sizeOfOriginalImage = this.imageCompress.byteCount(image);
    console.log('Size in bytes is now:', sizeOfOriginalImage);
    this.imageCompress.compressFile(image, -1, 50, 100).then(
      result => {
        var sizeOFCompressedImage = this.imageCompress.byteCount(result);
        console.log('Size in bytes after compression:', sizeOFCompressedImage);
        if (sizeOFCompressedImage > sizeOfOriginalImage) { // shortcut
          this.uploadtoDB(this.dataURLtoFile(image, fileName), fileName, reader);
        } else {
          this.uploadtoDB(this.dataURLtoFile(result, fileName), fileName, reader);
        }
      });
  }

  crop() {
    // Final gate before upload - cropping is free-form (no fixed aspect ratio/
    // output size), so a valid original image can still be cropped to the wrong
    // size. Only runs when a consumer opts in via expectedWidth/expectedHeight;
    // unset for every other consumer of this shared component, so this is a
    // no-op there.
    // ngx-image-cropper's own crop-region math can be off by a pixel or two from
    // the source image's true dimensions (canvas/CSS-pixel rounding) even when no
    // actual cropping happened - tolerate a small difference instead of requiring
    // byte-exact equality.
    const DIMENSION_TOLERANCE_PX = 2;
    if (this.expectedWidth && this.expectedHeight && this.matchExactDimension && this.cropDone &&
      (Math.abs(Math.round(this.cropDone.width) - this.expectedWidth) > DIMENSION_TOLERANCE_PX ||
        Math.abs(Math.round(this.cropDone.height) - this.expectedHeight) > DIMENSION_TOLERANCE_PX)) {
      if (this.showValidationToast) {
        this.alertService.error(`Upload image with correct width and height (${this.expectedWidth}x${this.expectedHeight})`);
        this.restorePreviousImage();
      } else {
        this.notAllowedList.push({
          fileName: this.fileInfo?.name,
          fileSize: this.fileInfo ? this.convertSize(this.fileInfo.size) : '',
          errorMsg: `Invalid dimensions - expected ${this.expectedWidth}x${this.expectedHeight}px, got ${Math.round(this.cropDone.width)}x${Math.round(this.cropDone.height)}px`
        });
      }
      return;
    }

    this.loader.showSpinner()
    if (this.configFile.settleImage) {
      this.changeImage(this, this.configFile.event, this.file[0] ? this.file[0] : this.fileInfo)
    } else {
      var reader = new FileReader();
      var croppedFile: any = this.dataURLtoFile(this.cropedImage, this.imageChanges.name)
      reader.onload = ((file) => {
        return (evt) => {
          const fileVal = {
            file: file,
            imageSrc: evt.target.result
          };
          console.log("byte count is 1 :: ", this.imageCompress.byteCount(croppedFile));
          if (this.imageCompress.byteCount(croppedFile) >= 1048576) {
          } else {
            this.selectedFiles.push(fileVal);
          }
        };
      })(croppedFile);
      reader.readAsDataURL(croppedFile);
      reader.onloadend = () => {
        console.log("byte count is :: ", this.imageCompress.byteCount(croppedFile));
        if (this.imageCompress.byteCount(croppedFile) >= 1048576)
          this.compressFile(croppedFile, this.imageChanges.name, reader) // by saurav deep compress file \
        else
          this.uploadContent(croppedFile, this.file[0].name, reader.result);
      };
    }

  }


  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  imageLoaded() {
    console.log("Show Cropper");
    // show cropper
  }
  cropperReady() {
    console.log("Cropper Ready");
    // cropper ready
  }
  loadImageFailed() {
    console.log("Show Message");
    // show message
  }
  onChange(event: any) {
    this.configFile.event = event;
    try {
      this.fileInfo = event.target.files[0];
    } catch (err) {
      console.log('catch error occured==>', err);
    }
    const that = this;
    this.showCaptureImage = false;
    this.currentMimeType = 'png';
    if (event.target.files[0].type != "") {
      this.currentMimeType = event.target.files[0].type.split("/")[1].toLowerCase();
      if (that.imageMimeType.includes(this.currentMimeType)) {
      } else {
        if (that.crop_image) {
          that.fileMimeTypebollean = true
          that.crop_image = false;
        }
      }
    } else {
      if (that.crop_image) {
        that.fileMimeTypebollean = true
        that.crop_image = false;
      }
    }

    this.notAllowedList = [];
    if (!this.multipleImageUpload) {
      if (this.afterUpload || !this.multiple) {
        this.selectedFiles = [];
        this.Caption = [];
        this.afterUpload = false;
      }
    }
    //FORMATS ALLOWED LIST
    //NO OF FORMATS ALLOWED
    let formatsCount: any;
    formatsCount = this.formatsAllowed.match(new RegExp('\\.', 'g'));
    formatsCount = formatsCount.length;

    //ITERATE SELECTED FILES
    //let file: FileList;
    if (event.type == 'drop') {
      this.file = event.dataTransfer.files;
    } else {
      this.file = event.target.files || event.srcElement.files;
    }
    let currentFileExt: any;
    let ext: any;
    let frmtAllowed: boolean;
    // files that passed format + size; their content is verified before upload
    const acceptedFiles: { file: File, ext: string }[] = [];
    for (let i = 0; i < this.file.length; i++) {
      //CHECK FORMAT
      //CURRENT FILE EXTENSION
      currentFileExt = this.reg.exec(this.file[i].name);
      currentFileExt = currentFileExt[1];
      frmtAllowed = false;
      //FORMAT ALLOWED LIST ITERATE
      for (let j = formatsCount; j > 0; j--) {
        ext = this.formatsAllowed.split('.')[j];
        if (j == formatsCount) {
          ext = this.formatsAllowed.split('.')[j] + ',';
        } //check format
        if (currentFileExt.toLowerCase() == ext.split(',')[0]) {
          frmtAllowed = true;
        }
      }

      if (frmtAllowed) {
        //CHECK SIZE
        if (this.file[i].size > this.maxSize * 1024000) {
          if (this.showValidationToast) {
            this.alertService.error(`Image size is larger than ${Math.round(this.maxSize * 1000)}KB`);
            this.restorePreviousImage();
          } else {
            this.notAllowedList.push({
              fileName: this.file[i].name,
              fileSize: this.convertSize(this.file[i].size),
              errorMsg: 'Invalid size'
            });
          }
          continue;
        }
        else {
          acceptedFiles.push({ file: this.file[i], ext: currentFileExt.toLowerCase() });
        }
      } else {
        // this.uploadBtn = false;
        if (this.showValidationToast) {
          this.alertService.error('Invalid file format');
          this.restorePreviousImage();
        } else {
          this.notAllowedList.push({
            fileName: this.file[i].name,
            fileSize: this.convertSize(this.file[i].size),
            errorMsg: 'Invalid format'
          });
        }
        continue;
      }
    }

    // #205111 - the extension (already matched against formatsAllowed) selects the content
    // rule; files that are disguised or carry scripts/macros never reach DMS.
    // inspectUploadFile never rejects, so Promise.all always resolves; results keep selection order.
    if (acceptedFiles.length) {
      const showSpinner = acceptedFiles.some(({ ext }) => requiresInspection(ext));
      const selectionSeq = ++this.selectionSeq;
      if (showSpinner) {
        this.loader.showSpinner();
      }
      Promise.all(acceptedFiles.map(({ file, ext }) => inspectUploadFile(file, ext))).then((results) => {
        if (showSpinner) {
          this.loader.hideSpinner();
        }
        // Single-file mode: a newer selection replaces this one - drop the stale result so a
        // slow inspection cannot overwrite the file the user picked afterwards.
        if (selectionSeq !== this.selectionSeq && !this.multiple && !this.multipleImageUpload) {
          return;
        }
        results.forEach((result, idx) => {
          if (result.allowed) {
            this.processAllowedFile(event, acceptedFiles[idx].file);
          } else {
            this.rejectUnsafeFile(acceptedFiles[idx].file, result.reason);
          }
        });
      });
    }
  }

  processAllowedFile(event, file) {
    if (!this.crop_image) {
      this.changeImage(this, event, file);
    } else {
      if (!this.multipleImageUpload) {
        if (this.crop_image && !this.multiple) {
          this.croppedImage = false;
          this.imageChangedEvent = event;
          this.imageChanges = file;
        } else {
          this.changeImage(this, event, file);
        }
      } else {
        this.changeImage(this, event, file);
      }
    }
  }

  rejectUnsafeFile(file: File, reason: string) {
    this.alertService.error('This document can’t be uploaded as it appears to be corrupted.');
    if (this.showValidationToast) {
      this.restorePreviousImage();
    } else {
      this.notAllowedList.push({
        fileName: file.name,
        fileSize: this.convertSize(file.size),
        errorMsg: reason
      });
    }
    // allow re-selecting the same file name after a rejection
    const input = document.getElementById('sel' + this.id) as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  changeImage(that, event, file) {
    // This is for single file, we need to upgrade for multifile
    //format allowed and size allowed then add file to selectedFile array
    // for (let i = 0; i < file.length; i++) {
    var reader = new FileReader();
    var toRead: any = file;
    var fileAr = toRead.name.split('.');
    var isManualChange = false;
    if ((fileAr[1].toLowerCase() != undefined && fileAr[1].toLowerCase() == 'dcm') || (fileAr[2] != undefined && fileAr[2] == 'dcm')) {
      toRead = new Blob([toRead], { type: "application/dicom" });
      toRead.name = file.name;
      isManualChange = true;
    }
    if ((fileAr[1].toLowerCase() != undefined && fileAr[1].toLowerCase() == 'plist') || (fileAr[2] != undefined && fileAr[2] == 'plist')) {
      toRead = new Blob([toRead], { type: "application/x-plist" });
      toRead.name = file.name;
      isManualChange = true;
    }
    if ((fileAr[1].toLowerCase() != undefined && fileAr[1].toLowerCase() == 'p8') || (fileAr[2] != undefined && fileAr[2] == 'p8')) {
      toRead = new Blob([toRead], { type: "application/x-authkey" });
      toRead.name = file.name;
      isManualChange = true;
    }
    reader.onload = ((file) => {
      return function (evt) {
        console.log("event is :: ", evt, "width is :: ");
        that.fileData = evt.target.result
        console.log("evt.target : ", that.fileData)
        const fileVal = {
          file: file,
          imageSrc: that.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file))
        };
        if (that.fileData.split(";")[0].split("/")[1] == 'dcm' || that.fileData.split(";")[0].split("/")[1] == 'dicom' || that.fileData.split(";")[0].split("/")[1] == 'pdf' || !that.compress_image) {
          that.selectedFiles.push(fileVal);
        }

        else if (that.imageCompress.byteCount(that.fileData) >= 1048576 && that.compress_image) {

        } else {
          that.selectedFiles.push(fileVal);
        }
      };
    })(toRead);
    if (this.config != undefined && this.config.isContent != undefined && this.config.isContent) {
      reader.readAsBinaryString(toRead);//reading raw content
    } else {
      reader.readAsDataURL(toRead);
    }

    reader.onloadend = () => {
      if (this.formSubmit) {
        let fileData = reader.result;
        this.value = fileData;
      } else {
        if (isManualChange) {
          this.uploadContent(toRead, toRead.name, reader.result);
        } else {
          if (!this.multipleImageUpload) {
            if (that.fileData.split(";")[0].split("/")[1] == 'pdf' || !that.compress_image)
              this.uploadContent(file, file.name, reader.result); //single file upload
            else
              if (that.imageCompress.byteCount(that.fileData) >= 1048576)
                this.compressFile(that.fileData, event.target.files[0]['name'], reader) // by saurav deep compress file \
              else {
                console.log("Reader ", reader.result);
                this.uploadContent(file, file.name, reader.result);
              }
          } else {
            this.readerFileData = reader;
            this.showUploadButton = true
          }
        }
      }
      that.validateButton(event);
    };
    // }
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this.file_id = val;
    this.propagateChange(val);
  }

  writeValue(value) {
    if (value) {
      if (this.multiple == true && typeof (value) == 'string') {
        try {
          this.question.value = JSON.parse(value);//182468, 182821 added because in case of template array value is getting in string format
          value = this.question.value;
        } catch (error) {
          console.log(error);
        }
      }
      this.file_id = value;
    }
  }

  private getValue(item: any, field: any) {
    const name = field.name;
    let value = null;
    value = item[name];
    return value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }

  validateButton(event) {
    if (this.selectedFiles.length !== 0) {
      this.uploadBtn = true;
      if (this.theme == 'attachPin') { this.uploadFiles(); }
    } else {
      this.uploadBtn = false;
    }
    //this.uploadBtn = true;
    this.uploadMsg = false;
    this.uploadClick = true;
    this.percentComplete = 0;
    event.target.value = null;
  }

  uploadFiles() {
    // this.progressBarShow = true;
    this.uploadClick = false;
    this.notAllowedList = [];
    this.uploadBtn = false;
    const isError = false;

    const data = this.selectedFiles[0]['imageSrc'];
    this.selectedFiles.forEach(selectedObj => {
      const base64 = this.base64(selectedObj.imageSrc);
      selectedObj.base64 = base64;
    });

    //this.uploadResponse.emit(this.selectedFiles);
  }

  removeuploadedFile(i: any, sf_na: any) {
    this.selectedFiles.splice(i, 1);
  }
  removeWithoutDelete(i){
    this.selectedFiles.splice(i, 1);
    this.Caption.splice(i, 1);
    this.value = "";
  }
  removeFile(i: any, sf_na: any) {
    if (this.config != undefined && this.config.isContent != undefined && this.config.isContent) {
      this.selectedFiles.splice(i, 1);
      this.Caption.splice(i, 1);
      this.value = "";
      this.delete.emit({ type: 'delete', id: this.id });
      return;
    }
    if (this.fileMimeTypebollean) {
      this.crop_image = true
    }

    if (this.formSubmit) {
      this.selectedFiles.splice(i, 1);
      this.file_id = '';
      this.showCaptureImage = true;
    } else {
      if (sf_na == 'sf') {
        this.loader.showSpinner()
        if (this.multiple) {
          this.subs.add(this.deleteImageApi$(this.file_id[i].documentId).subscribe((res) => {
            if (res) {
              this.delete.emit({ type: 'delete', id: this.file_id[i].documentId })
              this.file_id.splice(i, 1);
              this.selectedFiles.splice(i, 1);
              this.Caption.splice(i, 1);
              this.value = this.file_id;
              if (this.crop_image) {
                this.imageChangedEvent = '';
                this.croppedImage = false;
                this.cropedImage = '';
                document.getElementById("sel" + this.id)['value'] = ""
              }
              this.alertService.success(res.message);
              this.showCaptureImage = true;
              this.loader.hideSpinner();
            }
          }));
        } else {
          if(this.config != undefined &&  this.config.hideDeleteAPI){
            this.deleteImage(i);
          } 
          else{
            this.subs.add(this.deleteImageApi$(this.file_id).subscribe((res) => {
              if (res) {
                this.alertService.success(res.message);
                this.deleteImage(i);
              }
            }));
          } 
        }
      } else {
        this.notAllowedList.splice(i, 1);
      }
    }

    if (this.selectedFiles.length == 0) {
      this.uploadBtn = false;
    }
    this.loader.hideSpinner()
  }

  deleteImage(i) {
    if (this.multipleImageUpload) {
      this.selectedFiles = [];
    } else {
      this.selectedFiles.splice(i, 1);
    }
    this.Caption.splice(i, 1);
    this.value = "";
    this.loader.hideSpinner();
    if (this.crop_image) {
      this.imageChangedEvent = '';
      this.croppedImage = false;
      this.cropedImage = '';
      document.getElementById("sel" + this.id)['value'] = ""
    }
    this.showCaptureImage = true;
    this.delete.emit({ type: 'delete', id: this.id })
  }

  // DMS sometimes returns a blank/generic content-type (e.g. application/octet-stream)
  // for docx/doc uploads, which then fails every mime check in the template and the
  // attachment renders with no icon/click-handler at all. Fall back to the file
  // extension so known types still display and open correctly.
  private extensionToMimeType: { [ext: string]: string } = {
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'doc': 'application/msword',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'xls': 'application/vnd.ms-excel',
    'pdf': 'application/pdf',
    'odt': 'application/vnd.oasis.opendocument.text',
    'csv': 'text/csv'
  };

  inferFileType(type: string, name: string): string {
    if (type && type !== 'application/octet-stream') {
      return type;
    }
    const ext = (name || '').split('.').pop()?.toLowerCase();
    return (ext && this.extensionToMimeType[ext]) || type;
  }

  convertSize(fileSize: number) {
    return fileSize < 1024000
      ? (fileSize / 1024).toFixed(2) + ' KB'
      : (fileSize / 1024000).toFixed(2) + ' MB';
  }

  attachpinOnclick() {
    document.getElementById('sel' + this.id)!.click();
    //$("#"+"sel"+this.id).click();
  }

  clickImage() {
    let obj = { data: {}, title: 'Photos', size: DialogModalSize.Md, className: "modal-l" };
    this.subs.add(this.dialogService.open(ClickPhotoComponent, obj).afterClosed.subscribe(
      response => {
        if (response) {
          response["name"] = "kx-image-" + this.moment().valueOf() + ".jpeg";
          response['lastModified'] = this.moment().valueOf();
          response["webkitRelativePath"] = "";
          response["lastModifiedDate"] = this.moment();
          var p = [];
          p.push(response);
          this.onChange({ "target": { files: p } });
          this.showCaptureImage = false;
        }
      }
    ));
  }

  drop(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.onChange(event);
  }

  allowDrop(event: any) {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }

  base64(imageSrc: any) {
    return (imageSrc.substring(imageSrc.indexOf(',') + 1, imageSrc.length));
  }
  //jspdf is not used anywhere till date. We will add file multiple and send to DB 1 by 1.
  //If any issue exists come back to Aarti. 

  // createPdf(imgData: any) {
  //   this.showmultipleImage = false;
  //   this.showUploadButton = false;
  //   var doc = new jsPDF('p', 'pt', 'a4');
  //   var width = doc.internal.pageSize.width;
  //   var height = doc.internal.pageSize.height;
  //   // var options = {
  //   //   pagesplit: true
  //   // };
  //   for(let i = 0; i < imgData.length; i++) {
  //     doc.addImage(imgData[i].imageSrc, 'JPEG', 5, 5, width - 10, height - 10, "image" + i);
  //     if (i != imgData.length - 1) {
  //       doc.addPage();
  //     }
  //   }
  //   this.uploadtoDB(new Blob([doc.output('blob')], { type: 'application/pdf' }), "kx-image" + new Date().getTime() + ".pdf", this.readerFileData)
  // }

  uploadtoDB(file: any, name: any, reader) {
    console.log("file is :: ", file)
    reader.onload = ((file) => {
      return (evt) => {
        const fileVal = {
          file: file,
          imageSrc: evt.target.result
        };
        this.selectedFiles.push(fileVal);
      };
    })(event);
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.uploadContent(file, name, reader.result);
    };
  }

  uploadContent(content: File, fileName: string, fileContent?) {
    if (this.config != undefined && this.config.isContent != undefined && this.config.isContent) {
      if (this.config.contentBase64 != undefined && this.config.contentBase64) {
        this.value = btoa(fileContent);
      } else {
        this.value = fileContent;
      }

      this.documentInfo.emit({ fileInfo: this.fileInfo, data: {} });
      this.focus_out.emit(this.value);
    } else {
      this.loader.showSpinner();
      const formData = new FormData();

      if (this.question != undefined && this.question && this.question.s3Document != undefined && this.question.s3Document && content != undefined && content.type != undefined && content.type != 'application/dicom' && this.archive_metadata_check) {
        const s3Value = this.question?.doc_path;
        if(this.formService && this.formService.popupForm){
        this.setDataForS3(formData, this.formService.popupForm.value);
        }
        else if (s3Value != null) {
          this.setDataForS3(formData, s3Value);
                  const lastDotIndex = fileName.lastIndexOf('.');
                  const baseName =
                    lastDotIndex !== -1
                      ? fileName.substring(0, lastDotIndex)
                      : fileName;
                  const extension =
                    lastDotIndex !== -1
                      ? fileName.substring(lastDotIndex)
                      : '';
                  fileName = `${baseName}_${Date.now()}${extension}`;
                  console.log('Renamed File Name:', fileName);
         
        }   
      }

      formData.append('file', content,fileName);
      formData.append('fileName', fileName);
      formData.append('action', 'add');
      let userId: string = '';
      var currentOrg = this.appService.getOrganization();
      var currentUser = this.authenticationService.getCurrentUser();
      if (this.resource == 'orgImage' && currentOrg != undefined) {
        userId = currentOrg.org_id;
      } else if (this.resource == 'userImage' && currentUser != undefined) {
        userId = currentUser.id;//TODO:verify if its correct user id
      }
      formData.append('userId', userId);
      let documentResource = this.datasource['resource'] != undefined ? this.datasource['resource'] : this.resource;
      let application = this.datasource['application'] != undefined ? this.datasource['application'] : 'dms';
      // console.log("application is :: ", application, " ");
      this.subs.add(this.baseService.upload(formData, application, documentResource, fileContent).subscribe(
        (data: any) => {
          // console.log("Data is ", data);
          if (data.errCode != -1) {
            this.croppedImage = true;
            this.showCaptureImage = true;
            // this.value = data.documentId;
            if (this.multiple) {
              // 174000
              var p = { documentId: data.documentId, documentName: data.documentName }
              this.Arr.push(p);
              // console.log("this.value ", typeof this.value)
              if (this.value != undefined && typeof (this.value) == 'object' && this.value != 0)
                this.value.push(this.Arr[this.Arr.length - 1]);
              else
                this.value = this.Arr;
              if (this.value) {
                this.focus_out.emit(this.value);
              } else {
                this.focus_out.emit(data);
              }
            } else {
              this.value = data.documentId;
              this.documentInfo.emit({ fileInfo: this.fileInfo, data: data });
              // if (this.value) {
              //   this.focus_out.emit(data.documentId); // Need to re-check
              // }
              // for updating the document name
              data['fileSize'] = this.fileInfo.size
              this.focus_out.emit(data);
            }
          } else {
            this.resetFileUpload();
            this.alertService.error(data.message);
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.resetFileUpload();
          this.alertService.error(error);
          this.loader.hideSpinner();
        })
      );
    }
  }

  getfileData() {
    if (this.question != undefined && this.question && this.question.s3Document != undefined && this.question.s3Document && this.question?.resource) {
      if (Array.isArray(this.file_id)) {
        for (let i = 0; i < this.file_id.length; i++) {
          let url = this.baseService.getApiEndpoint("dms") + this.question.resource + "/image-response-entity?path=" + this.file_id[i].documentId;
          console.log("documentId_path is::"+ this.file_id[i].documentId);
          this.getImageData(url, true);
        }
      } else {
        let url = this.baseService.getApiEndpoint("dms") + this.question.resource + "/image-response-entity?path=" + this.file_id;
        console.log("documentId_path is::"+ this.file_id);
        this.getImageData(url, true);
      }
    }
   else{    
    let userId: string = '';
    var currentOrg = this.appService.getOrganization();
    var currentUser = this.authenticationService.getCurrentUser();
    if (this.resource == 'orgImage' && currentOrg != undefined) {
      userId = currentOrg.org_id;
    } else if (this.resource == 'userImage' && currentUser != undefined) {
      userId = currentUser.id;//TODO:verify if its correct user id
    }
    let documentResource = this.resource + '/image-response-entity';
    if (Array.isArray(this.file_id)) {
      for (let i = 0; i < this.file_id.length; i++) {
        let url = this.baseService.get_url('', "id:" + this.file_id[i].documentId, documentResource, 'dms');
        this.getImageData(url);
      }
    } else {
      let url = this.baseService.get_url('', "id:" + this.file_id, documentResource, 'dms');
      this.getImageData(url);
    }
  }
  }
  getImageData(url, isS3Document: boolean = false) {
    this.subs.add(this.baseService.getFileByUrlWithHeader(url, false).subscribe(res => {
      console.log('file res', res)
      let filename = res.headers.get('filename');
      res = res.body;
      let file = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res))
      let name = res.documentName ? res.documentName : filename ? filename : '';
      this.selectedFiles.push({
        imageSrc: file,
        file: {
          name: name,
          size: res.size,
          type: isS3Document ? this.inferFileType(res.type, name) : res.type,
          blob: res
        }
      });
    }));
    // this.baseService.get('', "id:"+this.file_id, documentResource, 'dms').subscribe(
    //   (data: any) => {
    //     this.docData = data.imageData;
    //     let contentType = 'data:' + data.contentType + ';base64, ';
    //     let imagebase64 = contentType + this.baseService.arrayBufferToBase64(data.imageData);
    //     this.imageURL = imagebase64;
    //     if (data && data.errCode && data.errCode == -1) { } else {
    //       const fileVal = {
    //         imageSrc: imagebase64,
    //         file: {
    //           name: data.documentName,
    //           size: data.size,
    //           contentType: data.contentType,
    //         }
    //       };
    //       this.selectedFiles.push(fileVal);
    //     }
    //   }
    // );
  }
  deleteImageApi$(data): Observable<any> {
    let documentResource = this.datasource['resource'] != undefined ? this.datasource['resource'] : this.resource;
    let application = this.datasource['application'] != undefined ? this.datasource['application'] : 'dms';
    const formData = new FormData();
    formData.append('id', data);
    formData.append('action', this.delete_document);
    formData.append('fileName', '')
    var key = btoa(data);
    return this.baseService.upload(formData, application, documentResource, key);
  }

  saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  };

  showImage(file: any) {
    if (file.file && file.file.type == 'load')
      return true;
    else if (file.file && this.imageMimeType.includes(file.file.type.split("/")[1].toLowerCase()))
      return true;
    else
      return false
  }
  openPdf(file) {
    console.log("File is ", file);
    if (file.file.type == 'application/pdf') {
      let blob = this.sanitizer.sanitize(4, file.imageSrc)
      let obj = { data: { 'url': blob, 'blob': blob, isBlob: true }, title: 'View Pdf', size: DialogModalSize.Lg };
      this.utilService.setCurrentPrintPopup(true);
      this.subs.add(this.dialogService.open(ShowPdfComponent, obj).afterClosed.subscribe(
        response => {
          this.utilService.setCurrentPrintPopup(false);
        }
      ));
    }
    if (file.file.type == 'text/plain') {
      var link = document.createElement('a');
      let blob = this.sanitizer.sanitize(4, file.imageSrc)
      link.href = blob;
      link.download = file.file.name;
      link.click();
    }

  }

  viewImage(i, sf: any) {
    let obj = { data: { 'documentId': this.file_id[i].documentId == undefined ? this.file_id : this.file_id[i].documentId, resource: this.datasource['resource'] != undefined ? this.datasource['resource'] : this.resource }, title: 'View Image', size: DialogModalSize.Lg };
    if (this.question?.s3Document !== null && this.question?.s3Document !== undefined) {
      obj.data['s3Document'] = this.question.s3Document;
    }
    this.subs.add(this.dialogService.open(ImageViewComponent, obj).afterClosed.subscribe(
      response => {

      }
    ));
  }

  clearInput(id) {
    this.showCaptureImage = true
    this.configFile.event = null;
    document.getElementById(id)['value'] = "";
  }

  // onChange() clears selectedFiles as soon as ANY new file is picked, before
  // format/size/dimension checks run - so a rejected file leaves the preview
  // empty instead of showing the still-unchanged existing image. Re-fetch it via
  // the still-valid file_id (nothing server-side has changed on a client-side
  // rejection) and reset the crop UI back to its pre-selection state.
  private restorePreviousImage(): void {
    this.croppedImage = true;
    this.cropedImage = '';
    this.imageChangedEvent = '';
    this.cropDone = undefined;
    this.clearInput('sel' + this.id);
    this.selectedFiles = [];
    if (this.file_id) {
      this.getfileData();
    }
  }
  validate(value: FormControl) {

  }

  isMobile() {
    return this.utilService.isMobile();
  }

  setDataForS3(formData, data) {
    try {
      if (data.uniqueFile == "") {    // for setting different image in same file name
        data.uniqueFile = false;
      }
      let payload = JSON.stringify(data);
      formData.append('resource', payload);

    } catch (error) {
      console.log(error);
    }
  }

  copyToClipboard(index: number) {
    let userId: string = '';
    var currentOrg = this.appService.getOrganization();
    var currentUser = this.authenticationService.getCurrentUser();
    if (this.resource == 'orgImage' && currentOrg != undefined) {
      userId = currentOrg.org_id;
    } else if (this.resource == 'userImage' && currentUser != undefined) {
      userId = currentUser.id;//TODO:verify if its correct user id
    }
    let documentResource = this.resource + '/image-response-entity';
    let url = '';
    if (Array.isArray(this.file_id)) {
      url = this.baseService.get_url('', "id:" + this.file_id[index].documentId, documentResource, 'dms');
    } else {
      url = this.baseService.get_url('', "id:" + this.file_id, documentResource, 'dms');
    }
    this.utilService.copyToClipboard(url).then(res => {
      this.alertService.success('Copied to clipboard', undefined, true);
    }).catch(err => {
      this.alertService.error('Failed to copy');
    });
  }
  // To download Doc File
  // blob URLs carry no name, so window.open saved doc/docx without an extension (shown as zip)
  downloadDocx(sf: any) {
    const blob: Blob = sf.file.blob || sf.file;
    const type = this.inferFileType(sf.file.type || blob.type, sf.file.name);
    this.utilService.downloadFile(blob, type, this.downloadFileName(sf.file.name, type));
  }

  private downloadFileName(name: string, type: string): string {
    const fileName = (name || '').trim() || 'document';
    const nameExt = fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : '';
    if (this.extensionToMimeType[nameExt]) {
      return fileName;
    }
    const typeExt = Object.keys(this.extensionToMimeType).find((ext) => this.extensionToMimeType[ext] === type);
    return typeExt ? fileName + '.' + typeExt : fileName;
  }

  // blob URLs carry no name, so window.open saves xls/xlsx without an extension (shown as zip)
  downloadExcel(sf: any) {
    const blob = sf.file.blob || sf.file;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = sf.file.name || 'document.xlsx';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}